module.exports = __webpack_public_path__ + "img/mr.f0c6d614.svg";